import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { IAppState } from 'app/store';
import { RoleService } from 'app/shared/services/role.service';
import { Role } from 'app/shared/models/role';
import { RoleKey } from '../../models/keys/role-key';
import { map } from 'rxjs/operators';
import { KeyBase, IEntity, ItemAdded, ItemChanged, SortExpression } from '@kpd/framework-ngx';
import { environment } from 'environments/environment';
import { UserManagementEntityFacade } from './usermanagement.facade';

@Injectable()
export class RoleFacade extends UserManagementEntityFacade {
  roleUsersSortExpression: SortExpression;

  constructor(private roleService: RoleService, store: Store<IAppState>) {
    super('roles', store, roleService, environment);
  }

  saveItem(role: Role): Observable<Role> {
    const subject = new Subject<Role>();
    this.roleService.save(role).subscribe(
      (updatedRole) => {
        if (role.isNew()) {
          this.store.dispatch(new ItemAdded('roles', updatedRole));
        } else {
          this.store.dispatch(new ItemChanged('roles', updatedRole, role.key));
        }
        this.roleService.clearRolesCache();
        subject.next(updatedRole);
        subject.complete();
      },
      (error) => {
        subject.error(error);
        subject.complete();
      },
    );
    return subject;
  }

  composeKeyByRouteParams(params: { name: string; application: string }): KeyBase {
    return RoleKey.composeKeyByRouteParams(params);
  }

  createNewEntity(): IEntity {
    return new Role();
  }

  canManageRole(roleKey: RoleKey): Observable<boolean> {
    return this.roleService.getAppsWithRoles().pipe(
      map((apps) => {
        return apps.some(
          (app) => app.name === roleKey.application && app.roles.some((role) => role.name === roleKey.name),
        );
      }),
    );
  }
}
